import React, { Component } from 'react';
import { Collapse } from 'components';
import styled from '@emotion/styled';
import { Colors } from 'utils';
import PropTypes from 'prop-types';
import '../ProjectForm/components/RichTextCss.css';
import '../Project/components/project_details.css';
import DOMPurify from 'dompurify';

const ProjectFAQsWrapper = styled.div`
  .project__collapse {
    padding-bottom: 10px;
    padding-top: 10px;
    border-bottom: 0.5px solid ${Colors.secondaryColor};
    h2 {
      font-size: 22px;
      font-weight: 600;
    }
    p {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      margin-bottom: 15px;
      color: ${Colors.steel};
    }
  }
`;

const FaqHtmlContent = styled.div`
  font-size: 20px;
  line-height: 32px;
  font-weight: 400;
  color: ${Colors.steel};
  overflow-wrap: anywhere;

  p {
    margin: 0 0 15px;
  }

  p:last-child {
    margin-bottom: 15px;
  }
`;

export default class ProjectFAQs extends Component {
  state = {
    currentOpen: null,
  };
  setCurrentOpen = (state, witchQut) => {
    if (state) {
      this.setState({ currentOpen: witchQut });
    } else {
      this.setState({ currentOpen: null });
    }
  };

  render() {
    const { currentOpen } = this.state;
    const { projectFaq, isTicketable } = this.props;
    const faqItems = [
      {
        key: 'projectInfo',
        index: 0,
        title: isTicketable
          ? 'Was ist der Zweck der Veranstaltung?'
          : 'Was ist der genaue Zweck des Projektes?',
      },
      {
        key: 'projectGoal',
        index: 1,
        title: isTicketable
          ? 'Was sind die Ziele – und wer ist die Zielgruppe?'
          : 'Was sind die Ziele und wer ist die Zielgruppe?',
      },
      ...(isTicketable
        ? [
            {
              key: 'projectPeople',
              index: 4,
              title: 'Wer sind die Organisatoren der Veranstaltung?',
            },
          ]
        : [
            {
              key: 'projectSupport',
              index: 2,
              title: 'Wofür werden die Unterstützungen verwendet?',
            },
            {
              key: 'projectMoney',
              index: 3,
              title:
                'Wie sorgst du für Transparenz und einen verantwortungsvollen Umgang mit den Unterstützungen?',
            },
            {
              key: 'projectPeople',
              index: 4,
              title: 'Wer ist in diesem Projekt involviert?',
            },
          ]),
    ];

    return (
      <ProjectFAQsWrapper>
        <div>
          {faqItems.map((item) => (
            <Collapse
              key={item.key}
              title={<h3>{item.title}</h3>}
              arrowWidth={'20px'}
              className="project__collapse"
              defaultState={currentOpen === item.key}
              handleMultiCollapes={this.setCurrentOpen}
              witchQuestions={item.key}
            >
              <FaqHtmlContent
                className="text_area_view_project"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    (projectFaq && projectFaq[item.index]) || '',
                    {
                      ALLOWED_TAGS: [
                        'b',
                        'strong',
                        'i',
                        'em',
                        'u',
                        'p',
                        'br',
                        'ul',
                        'ol',
                        'li',
                        'a',
                      ],
                      ALLOWED_ATTR: ['href', 'target', 'rel'],
                    }
                  ),
                }}
              />
            </Collapse>
          ))}
        </div>
      </ProjectFAQsWrapper>
    );
  }
}

ProjectFAQs.propTypes = {
  projectFaq: PropTypes.array,
  isTicketable: PropTypes.bool,
};

ProjectFAQs.defaultProps = {
  isTicketable: false,
};
